<template>
	<div class="pages content">
		<section class="pages-info-cont">
			<z-input :value="params.phone" title="用户名" disabled="disabled"></z-input>
			<div class="m-t-20">
				<z-input v-model.trim="params.username" title="商户名称" :maxlength = 20 isMust = true></z-input>
			</div>
			<div class="fx fx-y-center m-t-20">
				<div class="title fx w120 m-r-5"><p class="ask-cont"><i class="ask">*</i></p><span class="fx-fill">商户头像</span></div>
				<z-upload :file-url='params.logoUrl' :on-success="handleUploadSuccess"></z-upload>
				<div class="pic-tips m-l-10">建议尺寸：200*200</div>
			</div>
			<!--<z-input class="m-t-10" v-model="params.phone" title="商户手机号" disabled="disabled"></z-input>-->
			<div class="m-t-20 fx">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleValidation">保存</a>
			</div>
		</section>
	</div>
</template>
<script>
	import { mapState,mapActions } from 'vuex'
	export default {
		name: 'Info',
		data() {
			return {
				listArr:[],
				params:{
					phone:'',
					username:'',
					logoUrl:null
				},
				fileUrl:''
			}
		},
		props: {//接收父组件数据
			
		},
		watch :{//监听数据变化
			'userInfo':function(val){
				this.initData()
			}
	  	},
	  	mounted() {
	  		this.initData()
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				userInfo: state => state.users.userInfo
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			initData(){
				this.params.phone = this.userInfo.phone
				this.params.username = this.userInfo.username
				this.params.logoUrl = this.userInfo.logo_url
			},
			handleUploadSuccess(url){//图片上传成功回调
				this.params.logoUrl = url
			},
			async handleValidation(){//验证表单
				if(!this.params.username) return this.$warning('请输入昵称 /(ㄒoㄒ)/~~')
				if(!this.params.logoUrl) return this.$warning('请上传头像 /(ㄒoㄒ)/~~')
				try{
					await this.modifyUserInfo(this.params)
					this.$success('保存成功')
				}catch(e){
					this.$errorMsg('保存失败')
				}
			},
			...mapActions(['modifyUserInfo']),
		}
	}
</script>
<style  lang="scss">
@import "src/assets/css/common.scss";
	.pages-info-cont{
		width: 400px;
		
	}	
</style>


// WEBPACK FOOTER //
// Info.vue?a67f2580